export default {
  comments: null,
  rights: null,
  isLoading: false,
  isSubmitting: false,
  errors: null,
  validationErrors: null,
};
